import React from 'react'
import DealsBanner from './DealsBanner'
import DealsCards from './DealsCards'

export default function DealIndex() {
  return (
    <>
      <DealsBanner />
      <DealsCards />
    </>
  )
}
